class Deferred {
  constructor() {
    this._canceled = false
    this._promise = new Promise((resolve, reject) => {
      this._resolve = value => !this._canceled && resolve(value)
      this._reject = value => !this._canceled && reject(value)
    })
  }

  resolve(value) {
    this._resolve(value)
  }

  reject(value) {
    this._reject(value)
  }

  then(onFulfilled, onRejected) {
    this._promise.then(onFulfilled, onRejected)
  }

  cancel() {
    this._canceled = true
  }
}

export default Deferred
